var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Slide',[_c('a',{attrs:{"id":"home","href":"#"}},[_c('span',[_vm._v("Home")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }